import BaseStore    from "../../../App/Data/Store/BaseStore";
import AuthResource from "../ApiResources/AuthResource";

export default class User extends BaseStore {
    module = ['User'];

    getId() {
        return this.state('id');
    }

    set(user) {
        this.commit('setUser', user);
    }

    async login(email, password) {
        let authResource = new AuthResource();
        return authResource.login({email, password});
    }

    async logout() {
        await new AuthResource().logout();

        window.location.href = '/';
    }

}
